import businessUnit from './businessUnit';

export default {
	businessUnitPage: businessUnit
}